<x-chartist [type]="'Bar'" [data]="horizontalData" [options]="horizontalOptions" class="height-300">
</x-chartist>